import { doc, deleteDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { DeleteLabelParams } from "types/freelo/crud";

export const deleteLabel = async (params: DeleteLabelParams): Promise<void> => {
  const { boardId, labelId } = params;
  const labelRef = doc(db, "boards", boardId, "labels", labelId);
  await deleteDoc(labelRef);
}; 